import { jsx as _jsx } from "react/jsx-runtime";
// Importing custom components
import { Tooltip } from '../../core/tooltip';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useSiteStore } from '../../../store/site.store';
// Importing 3rd party components
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
// ----------------------------------------------------------------------
export const LicenseIcon = (props) => {
    // Destructuring props
    const { license } = props;
    // Adding site store
    const { site } = useSiteStore(useShallow((state) => ({
        site: state.site,
    })));
    return (_jsx(Link, { href: license.link, rel: "noreferrer", sx: {
            display: 'flex',
        }, target: "_blank", children: _jsx(Tooltip, { placement: "top", title: license.conditions, children: _jsx(Box, { component: "img", src: `${site === null || site === void 0 ? void 0 : site.url}/wp-content/plugins/cba/modules/cba-player/assets/icons/licenses/${license.license}.svg`, sx: {
                    height: 'auto',
                    maxWidth: '75px',
                    width: '100%',
                } }) }) }));
};
